import { render, staticRenderFns } from "./ResourceuploadBrowsing.vue?vue&type=template&id=ec4bca44&scoped=true"
import script from "./ResourceuploadBrowsing.vue?vue&type=script&lang=js"
export * from "./ResourceuploadBrowsing.vue?vue&type=script&lang=js"
import style0 from "./ResourceuploadBrowsing.vue?vue&type=style&index=0&id=ec4bca44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4bca44",
  null
  
)

export default component.exports